import { gql } from 'apollo-boost';

export const GENERATE_URL_SCREENSHOT = gql`
    mutation($data: GenerateUrlScreenshotInput!) {
        generateUrlScreenshot(data: $data) {
            url
            cdn_url
            thumbnail {
                sm
                md
                lg
                xl
                original
                compressed {
                    sm
                    md
                    lg
                    xl
                    original
                }
            }
            name
            displayName
            type
            format
            size
            mime
            width
            height
            aspect_ratio
        }
    }
`;
